/**
 * Keep hover-only product-card previews from running on touch devices.
 *
 * iOS Safari can report touch-generated pointer events as `mouse`, so the
 * pointerType checks in Horizon's product-card handlers are not sufficient on
 * their own. Only a real mouse on a hover-capable device may reach the PLP's
 * pointerenter/pointerleave handlers. Swatch click/change events are untouched.
 */
(function () {
  var hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

  function guardPlpHover(event) {
    if (hoverQuery.matches && event.pointerType === 'mouse') return;

    var target = event.target;
    if (!(target instanceof Element)) return;
    if (!target.closest('results-list product-card')) return;

    event.stopImmediatePropagation();
  }

  document.addEventListener('pointerenter', guardPlpHover, true);
  document.addEventListener('pointerleave', guardPlpHover, true);
})();
